import React from 'react'
import BreadCrumb from '../components/BreadCrumb'
import Header from '../components/header'
import Footer from '../components/footer'

function TermsPage() {
  const pageName = "Terms Of Service"
  return (
    <div className='home-3'>
      <Header/>
      <BreadCrumb pageName={pageName}/>
      <main>
        <div class="py-120">
          <div class="container">
              <div class="row">
                <div class="col">
                    <div class="terms-content">
                        <h3>Our Performance</h3>
                        <p>
                            We strive to provide high-quality services and ensure system uptime and reliability. However, we do not guarantee 
                            uninterrupted access to our services due to unforeseen circumstances such as maintenance, system failures, or 
                            external disruptions. We continuously work to improve our offerings and appreciate user feedback to enhance our performance.
                        </p>
                    </div>
                    <div class="terms-content">
                        <h3>Cookie Policy</h3>
                        <p>
                            Our website uses cookies to enhance user experience, analyze site traffic, and personalize content. By using our 
                            services, you consent to our use of cookies in accordance with our Privacy Policy. You can manage cookie preferences 
                            through your browser settings.
                        </p>
                    </div>
                    <div class="terms-content">
                        <h3>Payments</h3>
                        <p>
                            All payments for our services must be made through the accepted payment methods displayed on our platform. We ensure 
                            secure transactions, but we are not responsible for third-party payment processing delays or failures. All charges 
                            are non-refundable unless stated otherwise in our Refund Policy.
                        </p>
                    </div>
                    <div class="terms-content">
                        <h3>Refund Policy</h3>
                        <p>
                            Refunds are only applicable under specific circumstances such as service failure due to our negligence. Customers 
                            must request a refund within 14 days of the transaction, providing valid reasons and proof of the issue. Refund 
                            requests will be reviewed and processed within a reasonable timeframe.
                        </p>
                    </div>
                    <div class="terms-content">
                        <h3>Hyperlinking to Our Content</h3>
                        <p>Organizations may link to our website under the following conditions:</p>
                        <ul class="terms-list ms-4">
                            <li>1. The link must not misrepresent our services or imply false associations.</li>
                            <li>2. The linking website should not contain offensive or unlawful content.</li>
                            <li>3. We reserve the right to request the removal of any link to our website.</li>
                        </ul>
                    </div>
                    <div class="terms-content">
                        <h3>Disclaimer</h3>
                        <p>
                            We provide our services "as is" without warranties of any kind, express or implied. We do not guarantee that our 
                            services will be error-free, uninterrupted, or meet specific user requirements. We are not liable for any direct or 
                            indirect damages resulting from the use of our services.
                        </p>
                    </div>
                  </div>
              </div>
          </div>
        </div>
      </main>
      <Footer/>
    </div>
  )
}

export default TermsPage